import { TENANT_META } from '@cockpit/ui'
import { cn } from '@cockpit/ui'

/**
 * Small colored identity dot for a tenant, driven by the UI status registry's
 * `TENANT_META`. Unknown slugs fall back to a neutral gray.
 */
export function TenantDot({ slug, className }: { slug: string; className?: string }) {
  const meta = (TENANT_META as Record<string, { colorVar?: string } | undefined>)[slug]
  const color = meta?.colorVar ? `var(${meta.colorVar})` : 'var(--tone-neutral)'
  return (
    <span
      aria-hidden="true"
      className={cn('inline-block h-2 w-2 shrink-0 rounded-full', className)}
      style={{ backgroundColor: color }}
    />
  )
}
